import React from 'react';
import Input from 'components/Input';
import { withTranslation } from 'react-i18next';
import { useFormContext } from "react-hook-form";
import { CheckCircle2, Circle } from 'lucide-react';

const StepThreeForm = ({ t }) => {

  const { watch } = useFormContext();
  const password = watch('password') || '';

  const checks = [
    { key: 'min', valid: password.length >= 8, label: t('misc.validations.min', { chars: 8 }) },
    { key: 'caps', valid: /[A-Z]/.test(password), label: t('misc.validations.caps') },
    { key: 'num', valid: /[0-9]/.test(password), label: t('misc.validations.num') },
    { key: 'symbol', valid: /[^A-Za-z0-9]/.test(password), label: t('misc.validations.symbol') }
  ]

  return (
    <div className="w-full mb-3">
      <Input
        name="password"
        type="password"
        label={t('registration.field.password')}
        placeholder={t('registration.field.password')}
        classList='!bg-white !border-border-lines rounded-lg placeholder:text-placeholder'
      />

      <div className="grid grid-cols-2 gap-2 mt-3">
        {
          checks.map(({ key, valid, label }) => (
            <div
              key={key}
              className={`flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border ${valid ? 'bg-success/10 border-success text-success' : 'border-border-lines text-secondary'}`}
            >
              {valid ? <CheckCircle2 size={14} /> : <Circle size={14} />}
              <span>{label}</span>
            </div>
          ))
        }
      </div>

      <div className="w-full mt-5">
        <Input
          name="password_confirmation"
          type="password"
          label={t('registration.field.confirm_password')}
          placeholder={t('registration.field.confirm_password_placeholder')}
          classList='!bg-white !border-border-lines rounded-lg placeholder:text-placeholder'
        />
      </div>
    </div>
  )
}


export default withTranslation()(StepThreeForm);
